// Curated palette of visually distinct colors for mix codes.
// Ordered so that adjacent hues (in the hash-order sense) are perceptually far apart.
// Colors avoid orange (reserved accent) and dark blues (poor contrast on dark bg).

const PALETTE = [
  { hex: "#38BDF8" },   // 0  cyan
  { hex: "#A78BFA" },   // 1  violet
  { hex: "#F472B6" },   // 2  pink
  { hex: "#4ADE80" },   // 3  green
  { hex: "#FCD34D" },   // 4  amber
  { hex: "#2DD4BF" },   // 5  teal
  { hex: "#F87171" },   // 6  coral
  { hex: "#84CC16" },   // 7  lime
  { hex: "#818CF8" },   // 8  indigo
  { hex: "#D8B4FE" },   // 9  lavender
  { hex: "#7DD3FC" },   // 10 sky
  { hex: "#FDA4AF" },   // 11 rose
];

const cache = new Map();

export function mixColor(code) {
  if (!code) return withVariants("#71717A");
  if (cache.has(code)) return cache.get(code);

  // For codes with an embedded number (N20, N32, GP40, C30-HS...), spread
  // colors by dividing the number by 5. This gives visibly different hues
  // for adjacent common mix strengths (N20≠N25≠N32).
  const numMatch = code.match(/\d+/);
  let idx;
  if (numMatch) {
    const n = parseInt(numMatch[0], 10);
    idx = Math.floor(n / 5) % PALETTE.length;
    // Blend in a small hash offset from the non-numeric portion so codes like
    // "GP40" and "N40" still differ.
    const prefix = code.replace(/\d/g, "");
    let ph = 0;
    for (let i = 0; i < prefix.length; i++) ph = ph * 31 + prefix.charCodeAt(i);
    idx = (idx + (Math.abs(ph) % 3)) % PALETTE.length;
  } else {
    let h = 5381;
    for (let i = 0; i < code.length; i++) {
      h = ((h << 5) + h) + code.charCodeAt(i);
    }
    idx = Math.abs(h) % PALETTE.length;
  }
  const result = withVariants(PALETTE[idx].hex);
  cache.set(code, result);
  return result;
}

function withVariants(hex) {
  return {
    hex,
    border: hex,
    // 14% opacity fill for pill backgrounds
    bg: hexToRgba(hex, 0.14),
  };
}

function hexToRgba(hex, a) {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
